<template>
    <div class="main">
        <c-panel :title="titulo" titleIcon="fab fa-whatsapp">
            <conversas></conversas>
        </c-panel>
    </div>
</template>
<script>
import conversas from "./conversas"
export default {
    components: { conversas },
    data () { return { titulo: '' } },
    created () { this.titulo = (this.$route.meta && this.$route.meta.title) || 'Conversas do WhatsApp' }
}
</script>
